export default {"src":"/_next/static/media/zhk-brown-sm.23c622fa.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};